<template>
  <div class="function function-middle" id="service">
    <h5>我的服务</h5>
    <div class="function-detail">
      <ul>
        <li @click="EnterStoreClick">
          <i class="iconfont">&#xe611;</i>
          <p>我的店铺</p>
        </li>
        <li @click="goChecklist">
          <i class="iconfont">&#xe63e;</i>
          <p>结算清单</p>
        </li>
        <router-link tag="li" to="/yihuo_list">
          <i class="iconfont">&#xe61a;</i>
          <p>易货列表</p>
        </router-link>
        <router-link tag="li" to="/release">
          <i class="iconfont">&#xe620;</i>
          <p>发布易货</p>
        </router-link>
        <router-link tag="li" to="/post_trade">
          <i class="iconfont">&#xe67d;</i>
          <p>发布商品</p>
        </router-link>
        <router-link tag="li" to="/about">
          <i class="iconfont">&#xe680;</i>
          <p>关于我们</p>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'MeService',
  props: {
    shopid: String
  },
  methods: {
    EnterStoreClick () {
      // alert(this.shopid)
      this.$router.push({
        path: '/my_store',
        query: {
          shopid: this.shopid
        }
      })
    },
    goChecklist () {
      Toast('敬请期待')
    }
  }
}
</script>

<style scoped>
.function-detail ul{ display: flex; flex-wrap: wrap; justify-content: space-around; padding: 5px 0; border-bottom: 12px solid #f1f1f1; font-size: 14px;}
.function h5{ margin: 10px 17px; font-size: 14px; font-weight: bold; font-family: 'Arial,Microsoft YaHei';}
.function-detail{ text-align: center;}
.function-detail .iconfont{ font-size: 25px;}
.function-detail p{ margin-top: 3px; color: #7e7979;}
.function-detail li{ margin-bottom: 10px; list-style-type: none;}
.function-middle .iconfont{ color: #ceae85;}
.function-middle li{ width: 25%;}
.function-middle .item-last{ margin-bottom: 15px; margin-top: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/me/components/Service.vue